<div class="antrag-size-progress__bar" [class]="wrapperClass()" aria-hidden="true">
  <div
    class="antrag-size-progress__bar-progress"
    [ngClass]="{
      'antrag-size-progress__bar-progress--exceed': progress() >= 75,
      'antrag-size-progress__bar-progress--warn': progress() >= 55 && progress() < 75,
      'antrag-size-progress__bar-progress--ok': progress() < 55,
    }"
    [style.width.%]="progress()"></div>
</div>
<div class="antrag-size-progress__text">
  <ng-content />
</div>
